import { createRoot } from "react-dom/client";
import App from "./app/App.tsx";
import "./styles/index.css";
import 'lenis/dist/lenis.css';
import { supabase } from "./lib/supabase";

// Test connection to Supabase Auth API
supabase.auth.getSession().then(({ error }) => {
  if (error) {
    console.error("Supabase connection failed:", error.message);
  } else {
    console.log("Supabase connection successful! 🎉 Connected to project bvbzwdrduukpcgkmpzux.");
  }
});

createRoot(document.getElementById("root")!).render(<App />);